import React from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { Provider } from "../context";
import { SubtitlesProvider } from "../contextSubtitles";
import { ReelsProvider } from "../contextReels";
import { Debug } from "./Debug";
import { DragRange } from "./DragRange";
import { LayoutDragging } from "./LayoutDragging";
import { LayoutReels } from "./LayoutReels";
import { LayoutSubtitles } from "./LayoutSubtitles";
import { LayoutTranslate } from "./LayoutTranslate";
import { ConfigProvider } from "antd";
import reelsAntTheme from "./Reels/reels-ant-theme.json";
import { VideosProvider } from "providers/VideosProvider/videosProvider";
import { AudioProvider } from "providers/AudioProvider/audioProvider";
import { Videos } from "./views/videos";
import { Audios } from "./views/audios";
import { Stream, Stream2 } from "./views/stream";
import { NotificationProvider } from "../providers/NotificationProvider/NotificationProvider";
import { Login } from "./views/login";
import { ProtectedRoute } from "./layouts/ProtectedRoute";
import { AuthProvider } from "../providers/AuthProvider";

export function RoutesMain(props) {
    return (
        <>
            <Router>
                <NotificationProvider>
                    <AuthProvider>
                        <AudioProvider>
                            <Routes>
                                {/* Login Route - Public */}
                                <Route path="/login" element={<Login />} />

                                <Route
                                    path="/:mediaId"
                                    element={
                                        <>
                                            <Provider>
                                                <LayoutDragging />
                                                <Debug />
                                            </Provider>
                                        </>
                                    }
                                />

                                <Route
                                    exact
                                    path="/"
                                    element={
                                        // <Navigate to='/9020231925e711eebf6302420a000003?name=Олег_Геннадьевич_Торсунов_Короткая%20лекция&lang=english' />
                                        <Navigate to="/cldirx6z7000wvs0ykgx234jl?name=0057_Как_распознать_опасность_&lang=english&folder=2" />
                                    }
                                />

                                <Route
                                    exact
                                    path="/subtitles/:mediaId"
                                    element={
                                        <SubtitlesProvider>
                                            <LayoutSubtitles />
                                        </SubtitlesProvider>
                                    }
                                />
                                <Route
                                    exact
                                    path="/fast/:mediaId"
                                    element={
                                        <ProtectedRoute>
                                            <Audios />
                                        </ProtectedRoute>
                                    }
                                />

                                <Route
                                    exact
                                    path="/translate/:mediaId"
                                    element={
                                        <Provider>
                                            <LayoutTranslate />
                                        </Provider>
                                    }
                                />

                                <Route
                                    exsact
                                    path="/reels/"
                                    element={
                                        <ConfigProvider theme={reelsAntTheme}>
                                            <ReelsProvider>
                                                <LayoutReels />
                                            </ReelsProvider>
                                        </ConfigProvider>
                                    }
                                />

                                <Route
                                    exsact
                                    path="/test-videos/"
                                    element={
                                        <ConfigProvider theme={reelsAntTheme}>
                                            <VideosProvider>
                                                <Videos />
                                            </VideosProvider>
                                        </ConfigProvider>
                                    }
                                />

                                <Route
                                    exact
                                    path="/subtitles/:mediaId"
                                    element={
                                        // <Navigate to='/9020231925e711eebf6302420a000003?name=Олег_Геннадьевич_Торсунов_Короткая%20лекция&lang=english' />
                                        <Navigate to="/cldirx6z7000wvs0ykgx234jl?name=0057_Как_распознать_опасность_&lang=english&folder=2" />
                                    }
                                />

                                <Route exact path="/t3" element={<DragRange />} />
                                <Route exact path={"stream"} element={<Stream />} />
                                <Route exact path={"stream2"} element={<Stream2 />} />
                            </Routes>
                        </AudioProvider>
                    </AuthProvider>
                </NotificationProvider>
            </Router>
        </>
    );
}
